/* eslint-disable */
/* eslint-disable arrow-parens */
import React, { useState, useCallback, useEffect, useRef, useContext, Suspense } from "react";

import { ADMIN_DASHBOARD_HEADER } from "../../../../constants/caption/dashboardHeader";
import { AuthContext, UIContext } from "../../../../contexts";

import "date-fns";

import { Grid, Button, Paper, Select, FormControl, MenuItem, Snackbar } from "@material-ui/core";

import SendIcon from "@material-ui/icons/Send";
import BeenhereIcon from "@material-ui/icons/Beenhere";

import "./CoreDataGridV2.css";
import { api } from "../../../../utils/api";
import useRouteParam from "../../../../hooks/useRouteParam";
import { Validation } from "../../../../@types/validation.types";
import { trackPromise } from "react-promise-tracker";
import MuiAlert, { AlertProps } from "@material-ui/lab/Alert";
import JSONToExcel, { JSONToExcelWithTerminated } from "../../../../utils/commonFunctions/JSONToExcel";
import { group } from "console";
import GetAppIcon from "@material-ui/icons/GetApp";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ErrorIcon from "@material-ui/icons/Error";

const formatReportMonth = (reportMonth: string) => {
	const [year, month] = reportMonth.split("-").map(Number);
	const formattedMonth = new Date(year, month - 1, 1).toLocaleDateString("en-US", { month: "short", year: "numeric" });
	// console.log("formatReportMonth---", reportMonth, formattedMonth);
	return formattedMonth;
};


const CoreDataGridV2 = () => {
	const [isButtonSelected, setIsButtonSelected] = useState(true);

	const queryGroupNumber = useRouteParam("gn");
	const { setDashboardHeader } = useContext(UIContext);

	const { user } = useContext(AuthContext);

	const [validation, setValidation] = useState<Validation>({
		selectedPlan: {},
		status: "invalid"
	});
	const [isCalculating, setIsCalculating] = useState(false);
	const [isValidating, setIsValidating] = useState(false);
	const [openSnack, setOpenSnack] = useState(false);
	const [selectedPlan, setSelectedPlan] = useState<any>({
		plan_type: "CORE",
		plan_name: "",
		plan_code: ""
		// current_year: currentYear,
		// current_month: ""
	});
	const _validation = useRef<Validation>();
	const [planOptions, setPlanOptions] = useState<any[]>([]);

	const [isRecalculatedThisMonth, setIsRecalculatedThisMonth] = useState(false);
	const [lastRecalculatedOn, setLastRecalculatedOn] = useState<string | null>(null);
	const [isCheckingLastRun, setIsCheckingLastRun] = useState(false);
	const latestPlanCode = useRef("");

	// console.log("latestPlanCode--", latestPlanCode);
	const [reportMonthOptions, setReportMonthOptions] = useState<
		{
			report_month: string;
			recalculation_result_id: string;
			validation_result_id: string;
			is_equal_with_validation: boolean;
		}[]
	>([]);
	const [selectedReportMonth, setSelectedReportMonth] = useState<string>("");
	const latestMonthsPlanCode = useRef("");

	const [isDownloadingValidation, setIsDownloadingValidation] = useState(false);
	const [isDownloadingRecalculation, setIsDownloadingRecalculation] = useState(false);

	// const planOptions = useRef([
	// 	{
	// 		plan_name: "Health Plan",
	// 		plan_code: "HP-FT-2025"
	// 	},
	// 	{
	// 		plan_name: "Health Plan",
	// 		plan_code: "HP-PTIN-2025"
	// 	},
	// 	{
	// 		plan_name: "Clinic Card",
	// 		plan_code: "CC-PT-2025"
	// 	},
	// 	{
	// 		plan_name: "Clinic Card",
	// 		plan_code: "CC-PTIN-2025"
	// 	},
	// 	{
	// 		plan_name: "Group Long Term Disability(Class 2)",
	// 		plan_code: "GLTD-C2-FT-2025"
	// 	},
	// 	{
	// 		plan_name: "Group Short Term Disability",
	// 		plan_code: "GSTD-FT-2025"
	// 	}
	// ]);

	const handleValidation = useCallback(async () => {
		_validation.current = {
			...validation,
			selectedPlan: {},
			status: "invalid"
		};
		let flag = true;

		if (selectedPlan?.plan_name === undefined || selectedPlan?.plan_name === "") {
			_validation.current.selectedPlan["plan"] = "Plan is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}

		if (flag === true) {
			_validation.current["status"] = "valid";
		} else {
			_validation.current["status"] = "invalid";
			alert("Please, fill all required fields!");
		}

		setValidation(Object.assign({}, _validation.current));
		return _validation.current["status"];
	}, [selectedPlan, validation]);

	const getPlans = useCallback(async () => {
		try {
			const payload: any = {
				status: "ACTIVE",
				// plan_type: "CORE",
				group_number: queryGroupNumber
			};

			const response: any = await api.plan.getPlans(payload);
			console.log(payload, "Plans Response===>", response);
			if (response && response.length > 0) {
				const planOptions = response.map((plan: any) => ({
					plan_name: plan.plan_name,
					plan_code: plan.plan_code,
					_id: plan._id
				}));
				setPlanOptions(planOptions);
			}
		} catch (error) {
			console.error("Error fetching plans:", error);
		}
	}, [queryGroupNumber]);

	const handlePlanChange = useCallback(
		(event: React.ChangeEvent<HTMLInputElement | { name?: string | undefined; value: unknown }>) => {
			const { name, checked, value } = event.target as HTMLInputElement;

			const selectedPlanInstance = (event.target.value as string).split("=");
			const selectedPlanName = selectedPlanInstance[0];
			const selectedPlanCode = selectedPlanInstance[1];
			// const selectedPlanId = selectedPlanInstance[2];

			let field;
			// console.log("name", name, value);
			const selectedPlan = planOptions.find(
				(plan) => plan.plan_name === selectedPlanName && plan.plan_code == selectedPlanCode
			);
			if (selectedPlan) {
				// Update the selectedPlan state with both plan_name and plan_code
				setSelectedPlan((prevState: any) => ({
					...prevState,
					plan_name: selectedPlan.plan_name,
					plan_code: selectedPlan.plan_code,
					_id: selectedPlan._id
				}));
			}
		},
		[planOptions]
	);

	const loadLastRecalculationRun = useCallback(
		async (planCode: string) => {
			if (!planCode || !queryGroupNumber) return;

			latestPlanCode.current = planCode;
			setIsCheckingLastRun(true);
			try {
				const result = await api.premiumRecalculation.getLastRecalculationRun({
					plan_code: planCode,
					group_number: queryGroupNumber
				});
				if (latestPlanCode.current !== planCode) return; // user switched plan meanwhile

				setIsRecalculatedThisMonth(Boolean(result?.recalculated_this_month));
				setLastRecalculatedOn(result?.last_run_at ?? null);
			} catch (error) {
				console.error("Error fetching last recalculation run:", error);
				if (latestPlanCode.current !== planCode) return;

				setIsRecalculatedThisMonth(false);
				setLastRecalculatedOn(null);
			} finally {
				if (latestPlanCode.current === planCode) setIsCheckingLastRun(false);
			}
		},
		[queryGroupNumber]
	);


	const loadReportMonths = useCallback(
		async (planCode: string) => {
			setReportMonthOptions([]);
			setSelectedReportMonth("");
			if (!planCode || !queryGroupNumber) return;
			latestMonthsPlanCode.current = planCode;
			try {
				const months = await api.premiumRecalculation.getAvailableReportMonths({
					group_number: queryGroupNumber,
					plan_code: planCode
				});

				console.log("months from api--", months);

				if (latestMonthsPlanCode.current !== planCode) return;

				const monthList = Array.isArray(months) ? months : [];
				setReportMonthOptions(monthList);

			} catch (error) {
				console.log("Error fetching report months:", error);
			}
		},
		[queryGroupNumber]
	);

	const handleSubmitClick = useCallback(async () => {
		setIsCalculating(true);
		try {
			const validation = await handleValidation();
			if (validation === "valid" && queryGroupNumber) {
				const payload = {
					group_number: queryGroupNumber,
					plan_name: selectedPlan.plan_name,
					plan_code: selectedPlan.plan_code
				};
				// console.log("Payload===>", payload);
				const response: any = await api.premiumRecalculation.postPremiumRecalculationForm(payload);
				const reportFieldDetails = {
					alternative_report_name: "",
					group_number: queryGroupNumber
				};
				// console.log(response);

				if (response) {
					const fileName = "Premium Recalculation Report For " + `${selectedPlan.plan_code} `;

					const excelPayload = {
						user: {
							role: user?.role,
							name: user?.first_name + " " + user?.last_name
						},
						reportFieldDetails,
						response: response.recalculation_result.employee_details_premium_recalculation
						// response: response.report_rows,
						// terminated: response.terminated_employees
					};

					await trackPromise(JSONToExcel(excelPayload, fileName));
					await loadLastRecalculationRun(selectedPlan.plan_code);
				}

				setOpenSnack(true);
			}
		} catch (error) {
			console.error("Recalculation Error:", error);
			setOpenSnack(true);
		} finally {
			setIsCalculating(false);
		}
	}, [
		handleValidation,
		queryGroupNumber,
		selectedPlan.plan_code,
		selectedPlan.plan_name,
		user?.first_name,
		user?.last_name,
		user?.role,
		loadLastRecalculationRun
	]);

	const handleValidationClick = useCallback(async () => {
		setIsValidating(true);
		try {
			const validation = await handleValidation();
			if (validation === "valid" && queryGroupNumber) {
				const payload = {
					group_number: queryGroupNumber,
					plan_name: selectedPlan.plan_name,
					plan_code: selectedPlan.plan_code
				};
				// console.log("Payload===>", payload);
				const response: any = await api.premiumRecalculation.postPremiumValidationForm(payload);
				const reportFieldDetails = {
					alternative_report_name: "",
					group_number: queryGroupNumber
				};
				// console.log("API RESPONSE======", response);
				// console.log("TOP LEVEL KEYS:", Object.keys(response));

				if (response) {
					const fileName = "Premium Validation Report For " + `${selectedPlan.plan_code} `;

					// Frontend decrypting only those keys which is retuned by the service fn of result obj 
					const excelPayload = {
						user: {
							role: user?.role,
							name: user?.first_name + " " + user?.last_name
						},
						reportFieldDetails,
						response: response.employee_details_premium_recalculation,
						// response: response.report_rows,
						// terminated: response.terminated_employees
					};
					// console.log("object", response);
					await trackPromise(JSONToExcel(excelPayload, fileName));
				}
				// await new Promise((resolve) => {
				// 	setTimeout(() => {
				// 		console.log("Hi Api is calling...");
				// 		resolve("Recalculation complete");
				// 	}, 6000);
				// }).then((message) => {
				// 	console.log(message);
				// 	setOpenSnack(true);
				// });
				setOpenSnack(true);
				// } else {
				// 	console.error("Validation failed or group number is missing.");
			}
		} catch (error) {
			console.error("Recalculation Error:", error);
			setOpenSnack(true);
		} finally {
			setIsValidating(false);
		}
	}, [
		handleValidation,
		queryGroupNumber,
		selectedPlan.plan_code,
		selectedPlan.plan_name,
		user?.first_name,
		user?.last_name,
		user?.role
	]);

	const handleReportMonthChange = useCallback(
		(event: React.ChangeEvent<{ name?: string | undefined; value: unknown }>) => {
			setSelectedReportMonth(event.target.value as string);
		},
		[]
	);

	// validation result download handler
	const handleDownloadValidationClick = useCallback(async () => {
		setIsDownloadingValidation(true);
		try {
			const validation = await handleValidation();
			if (validation === "valid" && queryGroupNumber) {

				const selectedMonth = reportMonthOptions.find((month) => month.report_month === selectedReportMonth);
				if (!selectedMonth) {
					alert("Please select a report month!");
					return;
				}

				const payload = {
					group_number: queryGroupNumber,
					plan_code: selectedPlan.plan_code,
					report_month: selectedReportMonth,
					result_id: selectedMonth.validation_result_id
				};

				const response = await api.premiumRecalculation.getValidationReport(payload);

				if (!response) {
					alert("No validation report found for this month.");
					return;
				}

				const excelPayload = {
					user: {
						role: user?.role,
						name: user?.first_name + " " + user?.last_name
					},
					reportFieldDetails: {
						alternative_report_name: "",
						group_number: queryGroupNumber
					},
					response: response.report_rows,
					terminated: response.terminated_employees
				};

				const fileName = `Premium Validation Report For ${selectedPlan.plan_code} - ${formatReportMonth(selectedReportMonth)}`;

				await trackPromise(JSONToExcelWithTerminated(excelPayload, fileName));
				setOpenSnack(true);
			}
		} catch {
			console.log("Error downloading validation report");
		}
		finally {
			setIsDownloadingValidation(false);
		}
	}, [handleValidation, queryGroupNumber, selectedPlan.plan_code, selectedReportMonth, reportMonthOptions]);

	// recalculation result download handler
	const handleDownloadRecalculationClick = useCallback(async () => {
		setIsDownloadingRecalculation(true);
		try {
			const validation = await handleValidation(); // plan must be selected
			if (validation === "valid" && queryGroupNumber) {

				const selectedMonth = reportMonthOptions.find((month) => month.report_month === selectedReportMonth);
				if (!selectedMonth) {
					alert("Please select a report month!");
					return;
				}

				const payload = {
					group_number: queryGroupNumber,
					plan_code: selectedPlan.plan_code,
					report_month: selectedReportMonth,
					result_id: selectedMonth.recalculation_result_id

				};
				const response: any = await api.premiumRecalculation.getRecalculationReport(payload);

				if (!response) {
					alert("No recalculation report found for this month.");
					return;
				}

				const excelPayload = {
					user: {
						role: user?.role,
						name: user?.first_name + " " + user?.last_name
					},
					reportFieldDetails: {
						alternative_report_name: "",
						group_number: queryGroupNumber
					},
					response: response.report_rows,
					terminated: response.terminated_employees
				};
				const fileName = `Premium Recalculation Report For ${selectedPlan.plan_code} - ${formatReportMonth(selectedReportMonth)}`;

				await trackPromise(JSONToExcelWithTerminated(excelPayload, fileName));

			}
		} catch {
			console.log("Error downloading recalculation report");
		}
		finally {
			setIsDownloadingRecalculation(false);
		}
	}, [handleValidation, queryGroupNumber, selectedPlan.plan_code, selectedReportMonth, reportMonthOptions]);

	const Alert = (props: AlertProps) => {
		return <MuiAlert elevation={6} variant="filled" {...props} />;
	};

	const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
		if (reason === "clickaway") {
			return;
		}
		setOpenSnack(false);
	};

	useEffect(() => {
		// getPlans();
		setDashboardHeader(ADMIN_DASHBOARD_HEADER.premium_recalculation);
	}, [setDashboardHeader]);

	useEffect(() => {
		if (queryGroupNumber) {
			getPlans();
		}
	}, [getPlans, queryGroupNumber]);


	useEffect(() => {
		setIsRecalculatedThisMonth(false);
		setLastRecalculatedOn(null);
		loadLastRecalculationRun(selectedPlan.plan_code);
		loadReportMonths(selectedPlan.plan_code);
	}, [selectedPlan.plan_code, loadLastRecalculationRun, loadReportMonths]);

	// console.log("Plan selected", selectedPlan, queryGroupNumber);

	return (
		<>
			<div className="open-enrollment-container" id="open-enrollment-container">
				<Grid container spacing={1} className="pf-grid-container ">
					{/* <div className="pf-title">Open Enrollment for Employees</div> */}
					<Paper className="pf-paper-container " elevation={3} variant="outlined">
						<Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
							<Grid container spacing={1} className="pf-label">
								<Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
									<div className="pf-label-text required">Select Plan </div>
								</Grid>
								<Grid item xs={9} sm={9} md={9} lg={9} xl={9} className="plan-hyper-link-container">
									<FormControl variant="outlined">
										<Select
											className="frequency-container"
											name="plan"
											value={selectedPlan?.plan}
											onChange={handlePlanChange}
											// disabled={!isButtonSelected}
											style={{
												// cursor: !isButtonSelected ? "not-allowed" : "pointer",
												pointerEvents: "unset",
												width: 340,
												textAlign: "left",
												overflowY: "visible"
											}}
											MenuProps={{
												style: { zIndex: 35960 }
											}}
											inputProps={{ "aria-label": "Without label" }}
										>
											{planOptions.map((plan: any, index: number) => {
												const { plan_name, plan_code, _id } = plan;
												return (
													<MenuItem
														value={`${plan.plan_name}=${plan.plan_code}`}
														key={plan.plan_name}
													>
														<span className="plan-name-menu-item">{`${plan_name} -`}</span>
														<span className="plan-code-menu-item">{`${plan_code}`}</span>
													</MenuItem>
												);
											})}
										</Select>
										{validation?.selectedPlan?.plan ? (
											<div className="details">
												<span className="select-validation-text2">
													{validation.selectedPlan.plan}
												</span>
											</div>
										) : null}
									</FormControl>
								</Grid>
							</Grid>
						</Grid>
					</Paper>
				</Grid>

				<div className="pf-action-button-container enroll-action-btn">
					{/* for validation */}
					<Button
						className={`button-green ${isValidating ? "disabled" : ""}`}
						variant="contained"
						onClick={handleValidationClick}
						disabled={isValidating}
					>
						{/* <span className="button-label-with-icon">Submit</span> */}
						<span className="button-label-with-icon">
							{isValidating ? "Loading ..." : "Validate " + selectedPlan.plan_code}
						</span>
						<span>
							<BeenhereIcon className="button-icon" />
						</span>
					</Button>
					{/* for recalculation */}
					<Button
						className={`button-green ${isCalculating || isCheckingLastRun || isRecalculatedThisMonth ? "disabled" : ""}`}
						variant="contained"
						onClick={handleSubmitClick}
						disabled={isCalculating || isCheckingLastRun || isRecalculatedThisMonth}
					>
						<span className="button-label-with-icon">
							{isCalculating ? "Loading ..." : "Recalculate " + selectedPlan.plan_code}
						</span>
						<span>
							<SendIcon className="button-icon" />
						</span>
					</Button>
				</div>
				{isRecalculatedThisMonth && lastRecalculatedOn ? (
					<div className="details">
						<span className="select-validation-text2">
							Already recalculated this month on{" "}
							{new Date(lastRecalculatedOn).toLocaleDateString("en-US", { timeZone: "UTC" })}
						</span>
					</div>
				) : null}

				{/* Scheduled Reports: download what the scheduler stored */}
				<Grid container spacing={1} className="pf-grid-container">
					<Paper className="pf-paper-container" elevation={3} variant="outlined">
						<Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
							<div className="pf-title">Scheduled Reports</div>
							<Grid container spacing={1} className="pf-label">
								<Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
									<div className="pf-label-text required">Report Month </div>
								</Grid>
								<Grid item xs={9} sm={9} md={9} lg={9} xl={9}>
									<FormControl variant="outlined">
										<Select
											className="frequency-container"
											name="report_month"
											value={selectedReportMonth}
											onChange={handleReportMonthChange}
											style={{ width: 340, textAlign: "left" }}
											MenuProps={{ style: { zIndex: 10000 } }}
											inputProps={{ "aria-label": "Report month" }}
											disabled={!selectedPlan.plan_code}
										>
											{reportMonthOptions.map((month) => (
												<MenuItem key={month.report_month} value={month.report_month}>
													<div className="report-month-option">
														<span>{formatReportMonth(month.report_month)}</span>
														{month.is_equal_with_validation ? (
															<span className="report-month-badge count-matched">
																<CheckCircleIcon style={{ fontSize: 14 }} />
																Count matched
															</span>
														) : (
															<span className="report-month-badge count-unmatched">
																<ErrorIcon style={{ fontSize: 14 }} />
																Count missmatch
															</span>
														)}
													</div>
												</MenuItem>
											))}
										</Select>
									</FormControl>
								</Grid>
							</Grid>
						</Grid>
					</Paper>
				</Grid>

				<div className="pf-action-button-container enroll-action-btn">
					<Button
						className={`button-green ${isDownloadingValidation || !selectedPlan.plan_code ? "disabled" : ""}`}
						variant="contained"
						onClick={handleDownloadValidationClick}
						disabled={isDownloadingValidation || !selectedPlan.plan_code}
					>
						<span className="button-label-with-icon">
							{isDownloadingValidation ? "Loading ..." : "Download Validation"}
						</span>
						<span>
							<GetAppIcon className="button-icon" />
						</span>
					</Button>
					<Button
						className={`button-green ${isDownloadingRecalculation || !selectedPlan.plan_code ? "disabled" : ""}`}
						variant="contained"
						onClick={handleDownloadRecalculationClick}
						disabled={isDownloadingRecalculation || !selectedPlan.plan_code}
					>
						<span className="button-label-with-icon">
							{isDownloadingRecalculation ? "Loading ..." : "Download Recalculation"}
						</span>
						<span>
							<GetAppIcon className="button-icon" />
						</span>
					</Button>
				</div>

			</div>
			<Snackbar open={openSnack} autoHideDuration={6000} onClose={handleClose}>
				<Alert onClose={handleClose} severity="success">
					Premium recalculation successful!
				</Alert>
			</Snackbar>
		</>
	);
};

export default CoreDataGridV2;
